import { Col, FormCheck, FormControl, FormLabel, Row } from "react-bootstrap";
import { useState } from "react";
import RollDice from "../dice-rolling";


export default function RunningAground() {
	const [draft, setDraft] = useState(0);
	const [reefValue, setReefValue] = useState(0);
	const [hasDeckCrew, setDeckCrew] = useState(true);
	const [isAground, setIsAground] = useState("");

	function rollForRunningAground() {
		const modifiedDieRoll: number = RollDice(1)[0] - (hasDeckCrew ? 1 : 0);

		if (modifiedDieRoll > (draft + reefValue))
			setIsAground("Floating");
		else
			setIsAground("Aground")
	}

	return (
		<>
			<Row>
				<Col>
					<h1>Ship Draft Table (Running Aground)</h1>
				</Col>
			</Row>
			{isAground === "" ? null : (
				<Row className="p-3 text-center">
					<Col>
						<h1 className={isAground === "Floating" ? "text-success" : "text-danger"}>{isAground}</h1>
					</Col>
				</Row>
			)}
			{isAground !== "Aground" ? null : (
				<Row>
					<Col>
						<p><b>Damage From Running Aground:</b> Damage is equal to a <a href="ramming-and-oar-rake-attacks">Ram Attack</a> die roll. If moving at Battle Move Rate, add 25% damage (rounded down); if moving at Ramming Move Rate, add 50% damage (rounded down). Ships do not receive damage when attempting to free themselves from a reef.</p>
					</Col>
				</Row>
			)}
			<Row className="my-3">
				<Col>
					<FormLabel htmlFor="ship-draft">Ship Draft</FormLabel>
					<FormControl id="ship-draft" type="number" min={0} value={draft} onChange={(e) => setDraft(parseInt(e.target.value))} />
				</Col>
				<Col>
					<FormLabel htmlFor="reef-value">Reef Value</FormLabel>
					<FormControl id="reef-value" type="number" min={0} value={reefValue} onChange={(e) => setReefValue(parseInt(e.target.value))} />
				</Col>
			</Row>
			<Row>
				<Col>
					<FormCheck id="deck-crew" type="checkbox" label="Ship has at least one Deck Crew" checked={hasDeckCrew} onChange={(e) => setDeckCrew(e.target.checked)} />
				</Col>
			</Row>
			<Row className="mt-3">
				<Col xs={12}>
					<button className="btn btn-primary" onClick={() => rollForRunningAground()}>Roll for Running Aground</button>
				</Col>
				<Col className="mt-3">
					<button className="btn btn-danger" onClick={() => setIsAground("")}>Clear Results</button>
				</Col>
			</Row>
		</>
	);
}